import React from 'react';
import { useLocation } from 'react-router-dom';
import { MdAccountCircle, MdList } from 'react-icons/md';
import { SidebarItem, MenuAccordionItem } from '../SidebarComponents';

const AdminUsersMenu = () => {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname.startsWith(path);
  };

  const isAccordionActive = (parentPath) => {
    return location.pathname.startsWith(parentPath);
  };

  return (
    <MenuAccordionItem
      icon={MdAccountCircle}
      label="Usuários Admin"
      isActive={isAccordionActive('/webUsers')}
      defaultIsOpen={isAccordionActive('/webUsers')}
    >
      <SidebarItem
        icon={MdList}
        label="Lista de Usuários"
        to="/webUsers-list"
        active={isActive('/webUsers-list')}
        isSubmenuItem
      />
    </MenuAccordionItem>
  );
};

export default AdminUsersMenu;